/**
 * Created by rickborst on 24/07/2017.
 */

import {isValidResponse} from '../validators/settings';
import {convertFromRead, convertForConnectDevice, convertFromConnectDevice} from '../adapters/settings';
import { getSubscriptionPaymentMethod } from '../../../utils/firebase/remoteConfig';
import Settings from 'models/settings';


const APPLE_PAYMENT_METHOD = 'APPLE';

/**
 * Fetches and returns the settings data.
 *
 * @returns {Promise} Get settings promise.
 */

function getSettings () {
    let data = {},
        dataSources = this._dataSources;

    return dataSources.getActiveUser()
        .then(user => {

            data.personal = user;

            return Promise.all([
                dataSources.getPaymentDetails(),
                dataSources.getDevices(user)
            ]);
        })
        .then(results => {
            let paymentDetailsResponse = results[0],
                devicesResponse = results[1];
           

            if (!isValidResponse(paymentDetailsResponse)
                || !isValidResponse(devicesResponse)
            ) {
                return Promise.reject(results);
            }

            data.payment = paymentDetailsResponse;
            data.devices = devicesResponse;

            return data;
        })

        .then((paymentData)=> {
            if (paymentData.payment) {
                return getSubscriptionPaymentMethod().then((subscriptionPaymentMethods)=> {
                    let isNeedHideCardSection = false;
                    const parsedSubscriptionPaymentMethods = JSON.parse(subscriptionPaymentMethods._value);
                    
                    Object.keys(parsedSubscriptionPaymentMethods).forEach((paymentMethod) => {
                        if (paymentMethod === APPLE_PAYMENT_METHOD && parsedSubscriptionPaymentMethods[paymentMethod].includes(Number(data.payment.subscriptionId))) {
                            isNeedHideCardSection = true;
                        }
                    });
    
                    paymentData.payment.isNeedHideCardSection = isNeedHideCardSection;
                    
                    return paymentData;
                });
            } 
                return paymentData;
            
        })

        .then(results => {
            let settingsData = convertFromRead.call(this, results);
            
            return new Settings(settingsData);
        });
}

/**
 * Sends connect code to API to connect TV device.
 *
 * @param {string} connectCode - Connect code.
 * @return {Promise} ConnectDevice promise.
 */
function connectDevice (connectCode) {
    let url = this._baseUrl + this._endPoints.deviceConnect,
        data = convertForConnectDevice.call(this, connectCode);

    return this.read(
        {
            url: url,
            data: data
        })
        .then(response => {

            if (!isValidResponse(response)) {

                return Promise.reject(response);
            }

            return response;
        })
        .then(response => {
            return convertFromConnectDevice.call(this, response);
        });
}

export {
    getSettings,
    connectDevice
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/services/settings.js